import { Component, inject, Input, OnDestroy } from '@angular/core';
import { Subject } from "rxjs";
import { Site } from "../../../../domain/cloud-topology";
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { ScheduleService } from '../../../../services/vpp/schedule.service';
import { ConfirmModalComponent } from '../../../shared/confirm-modal/confirm-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-site-operations-battery',
    templateUrl: './site-battery.component.html',
    styleUrls: ['./site-battery.component.scss'],
    standalone: false
})
export class SiteBatteryComponent implements OnDestroy {

  @Input() site: Site;
  info = faInfoCircle;

  private subject$: Subject<void>;

  readonly dialog = inject(MatDialog);

  constructor(private scheduleService: ScheduleService,
              private snackBar: MatSnackBar) {
    this.subject$ = new Subject<void>();
  }

  ngOnDestroy(): void {
    this.subject$.next();
    this.subject$.complete();
  }

  stopSchedules() {
    if (!window.confirm('Are you sure you wish to stop ALL Schedules for the ' + this.site.name + ' Site?')) {
      return;
    }
    this.scheduleService.postStopActivities(this.site.id).pipe(takeUntil(this.subject$)).subscribe( (stopResponse) => {
      let totalStopped = 0;
      if (stopResponse && Object.keys(stopResponse).length > 0) {
        for (let responseKey in stopResponse) {
          if ( typeof stopResponse[responseKey] === 'number') {
            totalStopped += stopResponse[responseKey];
          }
        }
      }
      this.snackBar.open(`Stopped (${totalStopped}) Schedules ${this.site.name} .`, "Close", {
        duration: 3000,
        horizontalPosition: "right",
        verticalPosition: "bottom"
      });
    }, (error) => {
      console.log(`failed to stop schedules with error: `, error);
      this.snackBar.open("Problem stopping Schedules.", "Close", {
        duration: 3000,
        horizontalPosition: "right",
        verticalPosition: "bottom"
      });
    });
  }
}
